angular.module('core')
    .directive('localDateParser', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {

                //model to view
                ngModel.$formatters.push(value => {
                    if (value === null || value === undefined)
                        return value;
                    return moment(value).toDate();
                });

                //view to model
                ngModel.$parsers.push(value => {
                    if (value === null || value === undefined)
                        return value;

                    let date = new Date(value);
                    if (!isNaN(date.getTime())) {
                        return moment(date).format('YYYY-MM-DD');
                    }
                });
            }
        }
    })
